import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { EnvName, ThemeObject } from 'environments/env-name';

@Injectable({
  providedIn: 'root'
})
export class EnvThemeService {

  public environment = inject(PlexEnvironment);

  private bgColors: {}[] = [];
  private envName = this.environment.envName;
  private themeObject: ThemeObject | undefined;

  public getEnvStyle(): ThemeObject {
    let bgColor1: {};
    let bgColor2: {};
    
    if (this.themeObject) return this.themeObject;

    if (this.envName === EnvName.local) {
      bgColor1 = { 'background-color': '#848a86' };
      bgColor2 = { 'background-color': '#ffffff' };
      this.bgColors.push(bgColor1);
      this.bgColors.push(bgColor2);
      this.themeObject = { envName: this.envName, themeColors: this.bgColors };
      return this.themeObject;
    }
    if (this.envName === EnvName.dev) {
      bgColor1 = { 'background-color': '#848a86' };
      bgColor2 = { 'background-color': '#ffffff' };
      this.bgColors.push(bgColor1);
      this.bgColors.push(bgColor2);
      this.themeObject = { envName: this.envName, themeColors: this.bgColors };
      return this.themeObject;
    }
    if (this.envName === EnvName.test) {
      bgColor1 = { 'background-color': '#848a86' };
      bgColor2 = { 'background-color': '#ffffff' };
      this.bgColors.push(bgColor1);
      this.bgColors.push(bgColor2);
      this.themeObject = { envName: this.envName, themeColors: this.bgColors };
      return this.themeObject;
    }
    this.bgColors = [];
    this.themeObject = { envName: this.envName ?? '', themeColors: this.bgColors };
    return this.themeObject;
  }
}